/* eslint-disable camelcase */
import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import Sprite from '~components/Sprite'
import classNames from 'classnames'
import MediaQuery from '~components/helpers/MediaQuery'
import { register } from 'swiper/element/bundle'
import Zoom from '~components/Zoom'
import 'swiper/css'
import '~styles/components/swiper.scss'
register()

const Gallery = ({ title, images, className }) => {
  const galleryRef = useRef()
  const [open, setOpen] = useState(false)
  const [index, setIndex] = useState(1)

  const params = {
    spaceBetween: 0,
    breakpoints: {
      0: {
        spaceBetween: 1,
        slidesPerView: 1.25
      },
      690: {
        spaceBetween: 1,
        slidesPerView: 1.75
      }
    }
  }

  useEffect(() => initSwiper(), [])

  const hasImages = () => {
    return images && images.length > 0
  }

  const openZoom = (index) => {
    toggleOpen(true)
    setIndex(index)
  }

  const closeZoom = (e) => {
    toggleOpen(false)
    document.activeElement.blur()
  }

  const toggleOpen = (toggle) => setOpen(toggle)

  const initSwiper = () => {
    Object.assign(galleryRef.current, params)
    galleryRef.current.initialize()
  }

  return (
    <div className={classNames('w-full', className)}>
      <swiper-container
        ref={galleryRef}
        class="relative flex-grow lg:hidden"
        init="false"
      >
        {hasImages() && images.map(({ id, url_standard }, index) => (
          <swiper-slide key={index}>
            <button
              type="button"
              key={id}
              className="w-full px-0.25 my-0.25 h-0 pt-3/2 relative"
              onClick={() => openZoom(index)}
            >
              <img
                src={url_standard}
                alt={title}
                className="absolute top-0 left-0 block object-cover w-full h-full"
              />
            </button>
          </swiper-slide>
        ))}
      </swiper-container>

      <MediaQuery breakpoint="lg">
        <div className="flex flex-wrap -mx-0.25">
          {hasImages() && images.map(({ id, url_standard }, index) => {
            if (index === 0) {
              return (
                <button
                  type="button"
                  key={id}
                  className="w-full my-0.25 h-0 pt-3/2 relative"
                  onClick={() => openZoom(index)}
                >
                  <span
                    className="absolute z-10 block w-8 h-8 top-4 left-4"
                    aria-hidden="true"
                  >
                    <Sprite name="search" />
                  </span>

                  <img
                    src={url_standard}
                    alt={title}
                    className="px-0.25 block absolute top-0 left-0 object-cover w-full h-full"
                  />
                </button>
              )
            }

            return (
              <div
                className="w-1/2 my-0.25 relative"
                key={id}
                onClick={() => openZoom(index)}
              >
                <button
                  type="button"
                  className="w-full h-0 pt-3/2"
                >
                  <img
                    src={url_standard}
                    alt={title}
                    className="px-0.25 block absolute top-0 left-0 object-cover w-full h-full"
                  />
                </button>
              </div>
            )
          })}
        </div>
      </MediaQuery>

      {open && (
        <Zoom
          images={images}
          index={index}
          onClose={() => closeZoom()}
        />
      )}
    </div>
  )
}

Gallery.propTypes = {
  title: PropTypes.string,
  images: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    url_zoom: PropTypes.string,
    url_standard: PropTypes.string,
    url_thumbnail: PropTypes.string,
    url_tiny: PropTypes.string
  })),
  className: PropTypes.string
}

export default Gallery
